import React, { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from './Footer'
import Topnav from './topnav/Topnav'
import ToastSettings from '../config/ToastSettings'
import AddFloatingButton from './button/AddFloatingButton'
import TimerFloatingButton from './button/TimerFloatingButton'
import LocationSettings from '../config/LocationSettings'
import RowSpacer from './styles/RowSpacer'
import BookReadingSessionModal from '../routes/book/reading/BookReadingSessionModal'
import ReadingSessionSettings from '../routes/book/reading/ReadingSessionSettings'
import BookReadingSessionEndModal from '../routes/book/reading/BookReadingSessionEndModal'
import Confetti from 'react-confetti'
import useReadingSessionStore from '../routes/book/reading/useReadingSessionStore'
import useCurrentReadingSession from '../routes/book/reading/useCurrentReadingSession'
import FeedbackModal from '../routes/feedback/FeedbackModal'
import {useDarkMode} from "./hooks/DarkModeContext";
import {Helmet} from "react-helmet-async";
import usePageViewTracking from "./analytics/usePageViewTracking";

const Root = () => {
    const { isDark } = useDarkMode()

	const footerIncludeUrl = ['/', '/introductions', '/values', '/faq', 'products', '/products', '/products/*', '/privacy/2023-07-01', '/privacy/2023-08-03', '/community/*', '/community']
	const footerIncludePatterns = footerIncludeUrl.map(pattern => {
		const regexPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\\*/g, '.*')
		return new RegExp(`^${regexPattern}$`)
	})
	const isUrlIncluded = (url: string, patterns: RegExp[]) => {
		return patterns.some(pattern => pattern.test(url))
	}

	usePageViewTracking()

	const location = useLocation()
	const [currentUrl, setCurrentUrl] = React.useState('')
	useEffect(() => {
		setCurrentUrl(location.pathname)
	}, [location])

	const { width, height } = useWindowSize()
	const { isPlayConfetti } = useReadingSessionStore()

	const { currentReadingSession } = useCurrentReadingSession()
	const { updateCurrentReadingSession, stop } = useReadingSessionStore()
	useEffect(() => {
		if (currentReadingSession != null) {
			if (currentReadingSession.readingSession == null) {
				stop()
			} else {
				updateCurrentReadingSession(currentReadingSession)
			}
		}
	}, [currentReadingSession])

	return (
		<>
            <Helmet>
                <meta property={'og:title'} content={'책잇아웃'}/>
                <meta property={'og:description'} content={'읽고 있는 책 관리, 구독/도서관/중고서점 등 여러 곳에서 책 검색, 책과 관련된 유용한 정보까지. 책과 관련된 모든 것, 책잇아웃에서!'} />
            </Helmet>

			{isPlayConfetti && <Confetti width={width} height={height} />}

			<BookReadingSessionModal />
			<BookReadingSessionEndModal />
			<FeedbackModal />

			<Toaster
                toastOptions={{
                    style: {
                        backgroundColor: isDark ? 'rgba(55, 55, 55, 0.9)' : 'rgba(255, 255, 255, 0.95)',
                        color: isDark ? '#fff' : '#1a1a1a',
                        borderRadius: '16px',
                        padding: '14px 20px',
                        fontSize: '15px',
                        fontWeight: 600,
                        boxShadow: isDark ? '0 4px 12px rgba(0, 0, 0, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(8px)',
                        maxWidth: '400px',
                    },
                }}
                containerStyle={{
                    bottom: 40,
                }}
                position="bottom-center"
            />
			<ToastSettings />
			<LocationSettings />
			<ReadingSessionSettings />

			<Topnav />

			<Outlet />

			<TimerFloatingButton />
			<AddFloatingButton />

			{isUrlIncluded(currentUrl, footerIncludePatterns) && <Footer />}
			<RowSpacer style={{ backgroundColor: 'var(--primary-bg-color)' }} />
		</>
	)
}

function useWindowSize() {
	const [size, setSize] = React.useState({ width: window.innerWidth, height: window.innerHeight })

	React.useEffect(() => {
		const handleResize = () => {
			setSize({ width: window.innerWidth, height: window.innerHeight })
		}

		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return size
}

export default Root
